import React from 'react';

/**
 * MailEmptyState — shown in the reading pane when no email is selected.
 * BonusClub-branded: gradient envelope badge, brand-blue accents.
 */
export default function MailEmptyState() {
  return (
    <div className="ivx-detail-empty">
      <div className="ivx-detail-empty-badge">
        <div className="ivx-detail-empty-icon">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="4" width="20" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.6" />
            <path d="M3 7l9 6 9-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>
      <h3>Keine E-Mail ausgewählt</h3>
      <p>Wähle eine Nachricht aus der Liste, um sie hier zu lesen.</p>
      <span className="ivx-detail-empty-tag">BonusClub Inbox</span>
    </div>
  );
}
